import { z } from "zod";

export const create = z.object({
  name: z.string().min(1, "Required"),
  specimenTypeId: z.string(),
  fieldSetId: z.number({
    error: "Required",
  }),
  requireCentrifuge: z.boolean().prefault(false),
});

export const update = create.extend({ id: z.number() });

export const archive = z.object({ id: z.number() });
export const restore = z.object({ id: z.number() });

export const list = z.object({
  includeArchived: z.boolean().optional(),
});

export const activeTubeWhere = { archivedAt: null } as const;

export function isTubeArchived(tube: { archivedAt?: Date | null }) {
  return tube.archivedAt != null;
}
